export const Regex = {
  /**負の値を含む整数 */
  NUMBER_WITH_NEGATIVE: /^-?\d+$/,
  /**正の整数 */
  NUMBER: /^\d+$/,
};
